import {Tooltip} from 'platform/components';
import {Box, HStack, Icon, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {SpecificationItem} from '../types/SpecificationItem';

interface SpecificationChipsProps extends TestIdProps {
  items: SpecificationItem[];
}

/** Chips wrap onto further rows, so the row adapts to any preview width. */
export function SpecificationChips(props: SpecificationChipsProps) {
  return (
    <HStack spacing={2} wrap data-testid={props['data-testid']}>
      {props.items.map((item) => (
        <Tooltip key={item.key} label={item.label} placement="top">
          {/* Tooltip makes its wrapper a tab stop unless a child opts out; a chip is not interactive. */}
          <Box
            tabIndex={-1}
            backgroundColor="palettes.neutral.20.100"
            borderRadius="large"
            paddingHorizontal={3}
            paddingVertical={1}
            maxWidth="100%"
          >
            <HStack spacing={2} align="center">
              <Icon value={item.icon} size={4} color="text.secondary" />
              <Text
                size="small"
                alternative
                overflowWrap="anywhere"
                data-testid={suffixTestId(`specification-${item.key}`, props)}
              >
                {item.value}
              </Text>
            </HStack>
          </Box>
        </Tooltip>
      ))}
    </HStack>
  );
}
